<template>
  <div>
    <div id="modelShow"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    let data = decodeURIComponent(location.hash.split("=")[1]);
    this.viewers(data);
  },
  methods: {
    showModel(url) {
      var _this = this;
      var config = {
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
        theme: "light-theme",
      };
      var element = document.getElementById("modelShow");
      _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(element, config);
      var options = {
        docid: this.$store.state.baseUrl + url,
        env: "Local",
        offline: "true",
        useADP: false,
      };

      Autodesk.Viewing.Initializer(options, function () {
        _this.viewer.start();
        _this.viewer.loadModel(options.docid, {
          isAEC: true,
        });
        _this.viewer.addEventListener(
          Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
          function () {
            // _this.$message({
            //   type: "success",
            //   message: "模型加载完成",
            // });
          }
        );
      });
    },
  },
};
</script>

<style >
#modelShow {
  width: 100vw;
  height: 100vh;
}
</style>